import { Challenge } from '@redux/prop-types';

export function createAIAdditionalContext(challenge: Challenge) {
  console.log(challenge);

  const { instructions, description, title, challengeFiles } = challenge;

  const seedCode = challengeFiles
    ?.map(file => `${file.ext}\n${file.contents}`)
    .join('\n');

  const additionalContextString = `Enunciado da Questão \n
  Título: ${title} \n
  Instruções: ${instructions} \n
  Descrição: ${description} \n
  Código inicial: ${seedCode as string}
  `;
  return additionalContextString;
}
